import LegalPage from "@/components/LegalPage";
import { Link } from "react-router-dom";

/**
 * /privacy — Datenschutzerklärung (Platzhalter-Entwurf).
 *
 * ⚠️ NON-PUBLIC NOTICE:
 * Legal pages contain placeholders and must not be considered final until
 * operator data is inserted and reviewed.
 *
 * TODO: Konkrete Auftragsverarbeiter, Datenübermittlungen und Speicher-
 * fristen ergänzen, sobald die endgültige Infrastruktur feststeht.
 */
export default function Privacy() {
  return (
    <LegalPage
      title="Datenschutzerklärung"
      subtitle="Informationen zur Verarbeitung personenbezogener Daten bei der Nutzung von PineForge.AI."
      updatedAt="05.07.2026"
    >
      <Section n="1" title="Verantwortlicher">
        <p>
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO)
          ist:
        </p>
        <address className="not-italic block bg-[#12141C] border border-[#1E212B] rounded-lg p-4 my-3 text-zinc-200 text-sm">
          Gökhan Tan<br />
          Jägerhofallee 34<br />
          71638 Ludwigsburg<br />
          Deutschland<br />
          E-Mail: pineforgeai@gmx.de<br />
          Support: customerservice@pineforge.ai<br />
          Telefon: +49-160-4526226
        </address>
      </Section>

      <Section n="2" title="Kontakt bei Datenschutzfragen">
        <p>
          Anfragen zum Datenschutz richten Sie bitte an:{" "}
          <strong>customerservice@pineforge.ai</strong>.
        </p>
        <p className="text-zinc-400 text-xs">
          [TODO: Falls ein Datenschutzbeauftragter bestellt ist, hier dessen
          Kontaktdaten ergänzen.]
        </p>
      </Section>

      <Section n="3" title="Hosting">
        <p>
          PineForge.AI wird bei externen Hosting-Dienstleistern betrieben.
          Der konkrete Hoster verarbeitet in unserem Auftrag technisch
          notwendige Daten (z. B. IP-Adresse, Zugriffszeitpunkt).
        </p>
        <p className="text-zinc-400 text-xs">
          [TODO: Namen und Sitz des konkreten Hosters ergänzen. Nachweis der
          Auftragsverarbeitung gemäß Art. 28 DSGVO sicherstellen.]
        </p>
      </Section>

      <Section n="4" title="Server-Logs">
        <p>
          Beim Aufruf des Dienstes werden zur Sicherstellung des
          Betriebs technisch notwendige Logdaten verarbeitet (z. B.
          IP-Adresse, Zeitpunkt der Anfrage, aufgerufene URL, HTTP-Status,
          User-Agent). Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse an einem sicheren und stabilen Betrieb).
        </p>
      </Section>

      <Section n="5" title="Registrierung und Nutzerkonto">
        <p>
          Zur Nutzung von PineForge.AI ist ein Nutzerkonto erforderlich.
          Erhoben werden dabei: E-Mail-Adresse, ein Passwort (gehasht
          gespeichert), sowie technische Metadaten (z. B. Zeitstempel).
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung
          bzw. vorvertragliche Maßnahmen).
        </p>
      </Section>

      <Section n="6" title="Verarbeitung von Prompts und generierten Skripten">
        <p>
          Die von Nutzern eingegebenen Prompts, hochgeladenen Skripte und
          Chat-Nachrichten werden verarbeitet, um die angeforderte
          KI-gestützte Ausgabe zu erzeugen. Zur Beantwortung werden diese
          Eingaben an externe KI-Modelle (LLM-Anbieter) übermittelt.
        </p>
        <p className="text-zinc-400 text-xs">
          [TODO: Konkreten LLM-Anbieter/Dienstleister benennen (z. B.
          Betreiber des Emergent LLM-Zugangs). Prüfen, ob und wo
          Datenverarbeitung außerhalb der EU stattfindet und ob geeignete
          Garantien nach Art. 44 ff. DSGVO vorliegen (z. B. EU-Standard-
          vertragsklauseln).]
        </p>
        <p>
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Erbringung der
          vertraglichen Leistung). Der Nutzer soll keine personenbezogenen
          Daten Dritter in Prompts eingeben.
        </p>
      </Section>

      <Section n="7" title="Zahlungsabwicklung">
        <p>
          Zum aktuellen Zeitpunkt findet keine Zahlungsabwicklung statt.
          Sobald kostenpflichtige Abonnements aktiviert werden, ist geplant,
          Zahlungen über den Zahlungsdienstleister <strong>Stripe</strong>{" "}
          abzuwickeln. Dabei werden zahlungsrelevante Daten (z. B. Name,
          Rechnungsadresse, Zahlungsmittelinformationen) direkt zwischen dem
          Nutzer und Stripe verarbeitet.
        </p>
        <p className="text-zinc-400 text-xs">
          [TODO: Nach Aktivierung des kostenpflichtigen Checkouts konkrete
          Datenkategorien, Verantwortlichkeiten (getrennt Verantwortliche,
          gemeinsame Verantwortlichkeit oder Auftragsverarbeitung),
          Datenübermittlungen und Rechtsgrundlagen ergänzen.]
        </p>
      </Section>

      <Section n="8" title="Cookies / Local Storage">
        <p>
          PineForge.AI verwendet technisch notwendige Cookies bzw. Local-
          Storage-Einträge (z. B. für Session- und Auth-Tokens sowie
          UI-Präferenzen). Diese sind für die Funktionsfähigkeit des Dienstes
          erforderlich. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und lit. f
          DSGVO.
        </p>
        <p className="text-zinc-400 text-xs">
          [TODO: Sofern Tracking-/Analyse-Tools eingeführt werden,
          Einwilligungsbanner (Consent) und entsprechende Informationen
          ergänzen.]
        </p>
      </Section>

      <Section n="9" title="E-Mail-Kommunikation">
        <p>
          Wir verarbeiten E-Mail-Adressen und Kommunikationsinhalte, um auf
          Support-Anfragen zu antworten. Rechtsgrundlage ist Art. 6 Abs. 1
          lit. b und lit. f DSGVO.
        </p>
      </Section>

      <Section n="10" title="Rechtsgrundlagen nach DSGVO">
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Art. 6 Abs. 1 lit. b DSGVO – Erfüllung des Nutzungsvertrags.</li>
          <li>
            Art. 6 Abs. 1 lit. c DSGVO – Erfüllung rechtlicher Verpflichtungen
            (z. B. steuer-/handelsrechtliche Aufbewahrung).
          </li>
          <li>
            Art. 6 Abs. 1 lit. f DSGVO – berechtigte Interessen (sicherer,
            stabiler Betrieb, Missbrauchsprävention).
          </li>
          <li>
            Art. 6 Abs. 1 lit. a DSGVO – Einwilligung, soweit erforderlich.
          </li>
        </ul>
      </Section>

      <Section n="11" title="Speicherdauer">
        <p>
          Personenbezogene Daten werden nur so lange gespeichert, wie es zur
          Erbringung des Dienstes erforderlich ist oder gesetzliche
          Aufbewahrungspflichten dies vorsehen.
        </p>
        <p className="text-zinc-400 text-xs">
          [TODO: Konkrete Aufbewahrungsfristen (Account, Chatverläufe,
          generierte Skripte, Abrechnungsdaten) ergänzen, sobald finale
          Datenmodell- und Compliance-Entscheidungen getroffen sind.]
        </p>
      </Section>

      <Section n="12" title="Rechte der betroffenen Personen">
        <p>Betroffene Personen haben insbesondere folgende Rechte:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Auskunft (Art. 15 DSGVO)</li>
          <li>Berichtigung (Art. 16 DSGVO)</li>
          <li>Löschung (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch (Art. 21 DSGVO)</li>
          <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
          <li>
            Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)
          </li>
        </ul>
        <p>
          Zur Ausübung dieser Rechte genügt eine Nachricht an{" "}
          <strong>customerservice@pineforge.ai</strong>.
        </p>
      </Section>

      <Section n="13" title="Auftragsverarbeiter">
        <p>
          Für Hosting, Datenbankbetrieb, E-Mail-Versand, Zahlungsabwicklung
          und KI-Verarbeitung können technische Dienstleister eingesetzt
          werden. Die konkrete Liste der eingesetzten Dienstleister wird vor
          Aktivierung kostenpflichtiger Funktionen ergänzt. Mit diesen
          Auftragsverarbeitern werden Verträge gemäß Art. 28 DSGVO
          geschlossen.
        </p>
        <p className="text-zinc-400 text-xs">
          [TODO: Konkrete Auftragsverarbeiter (Hoster, Datenbankanbieter,
          LLM-Anbieter, E-Mail-Anbieter, Zahlungsdienstleister) mit
          Firmierung, Sitz und AVV-Referenz ergänzen.]
        </p>
      </Section>

      <Section n="14" title="Datenübermittlung in Drittländer">
        <p>
          Sofern personenbezogene Daten in Länder außerhalb des Europäischen
          Wirtschaftsraums übermittelt werden (z. B. bei Nutzung von
          US-basierten Diensten), erfolgt dies nur auf Grundlage
          entsprechender Garantien nach Art. 44 ff. DSGVO, insbesondere
          EU-Standardvertragsklauseln.
        </p>
        <p className="text-zinc-400 text-xs">
          [TODO: Konkrete Drittlandübermittlungen mit Rechtsgrundlage
          benennen, sobald diese feststehen.]
        </p>
      </Section>

      <Section n="15" title="Änderungen dieser Datenschutzerklärung">
        <p>
          Wir passen diese Datenschutzerklärung an, sobald technische oder
          rechtliche Änderungen dies erforderlich machen. Die jeweils aktuelle
          Version ist unter{" "}
          <Link
            to="/privacy"
            className="text-blue-400 hover:text-blue-300 underline underline-offset-2"
          >
            /privacy
          </Link>{" "}
          abrufbar.
        </p>
      </Section>
    </LegalPage>
  );
}

function Section({ n, title, children }) {
  return (
    <section data-testid={`privacy-section-${n}`}>
      <h2 className="text-lg font-semibold text-white mb-3 flex items-baseline gap-3">
        <span className="text-[11px] font-mono text-zinc-500 tabular-nums">§ {n}</span>
        <span>{title}</span>
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
